module.exports = __webpack_public_path__ + "static/media/table-fIlter-icon.967e605c.svg";